import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { isMobileOnly } from 'react-device-detect';
import DatePicker from 'react-datepicker';
import { connect, useDispatch } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import Select from 'react-select';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';
import {
  getDashboardRevenueData,
  handleDashboardRevenueLoader,
} from '../../../redux/actions/dashboardActions';
import CombinedCamparison from './combinedComparison';
import AmazonRevenue from './amazonrevenue';

export const filterShowWise = [{
  label: "Daily", value: 1
}, {
  label: "Monthly", value: 2
},
{
  label: "Yearly", value: 3
},
]

const Dashboard = ({ rtl }) => {
  const dispatch = useDispatch();

  const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0]);
  const [dateRange, setDateRange] = useState([
    new Date(moment().subtract(1, 'month')),
    new Date(moment()),
  ]);
  const [startDate, endDate] = dateRange;

  const callApi = () => {
    if (startDate && endDate) {
      dispatch(handleDashboardRevenueLoader(true, 'amazon'));
      dispatch(
        getDashboardRevenueData({
          fromdate: moment(startDate).format('YYYY-MM-DD'),
          todate: moment(endDate).format('YYYY-MM-DD'),
          vendor: 'amazon'
        }),
      );
      dispatch(handleDashboardRevenueLoader(true, 'shopify'));
      dispatch(
        getDashboardRevenueData({
          fromdate: moment(startDate).format('YYYY-MM-DD'),
          todate: moment(endDate).format('YYYY-MM-DD'),
          vendor: 'shopify'
        }),
      );
      dispatch(handleDashboardRevenueLoader(true, 'wholesale'));
      dispatch(
        getDashboardRevenueData({
          fromdate: moment(startDate).format('YYYY-MM-DD'),
          todate: moment(endDate).format('YYYY-MM-DD'),
          vendor: 'wholesale'
        }),
      );
    }
  }

  useEffect(() => {
    callApi()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <Container className="dashboard">
      <Row>
        <Col md={6} sm={12}>
          <h3 className="page-title mb-0">Dashboard</h3>
        </Col>
        <Col md={4} sm={12}>
          <div className="form__form-group mb-0">
            <div className="form__form-group-field">
              <div className="date-picker">
                <DatePicker
                  dateFormat="MM/dd/yyyy"
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  withPortal={isMobileOnly}
                  // eslint-disable-next-line max-len
                  value={`${moment(startDate).format('MM/DD/YYYY')} - ${endDate ? moment(endDate).format('MM/DD/YYYY') : 'Select End Date'
                    }`}
                />
              </div>
            </div>
          </div>
        </Col>
        <Col sm="2" className="pr-0">
          <div className="form__form-group mb-0">
            <div className="form__form-group-field ">
              <Select
                value={currentlyShow}
                options={filterShowWise}
                clearable={false}
                placeholder="Select "
                className="select_filter bg-white"
                onChange={value => setCurrentlyShow(value)}
                classNamePrefix="react-select"
              />
            </div>
          </div>
        </Col>
      </Row>
      <CombinedCamparison currentlyShow={currentlyShow} dir={rtl.direction} />
      <AmazonRevenue callApi={callApi} currentlyShow={currentlyShow} />

    </Container>
  );
};

Dashboard.propTypes = {
  rtl: RTLProps.isRequired,
};

const mapStateToProps = state => ({
  rtl: state.rtl,
});

export default connect(mapStateToProps)(Dashboard);
